import { apiFunction } from '../../Helpers/apiHelper'

export interface AuthUser {
  id: number
  name: string
  email: string
}

interface LoginResponse {
  message: string
  token: string
  user: AuthUser
}

interface LogoutResponse {
  message: string
}

interface UserResponse {
  user: AuthUser
}

/**
 * ログイン
 * 
 * @param email メールアドレス
 * @param password パスワード
 * @returns ログインユーザー情報
 * @throws Error 認証失敗時
 */
export const login = async (email: string, password: string): Promise<AuthUser> => {
  try {
    const result = await apiFunction<LoginResponse>(
      '/api/auth/login',
      { email, password },
      'POST'
    )
    
    if (!result || !result.user || !result.token) {
      throw new Error('ログインに失敗しました。')
    }

    // トークンをlocalStorageに保存
    localStorage.setItem('auth_token', result.token)

    return result.user
  } catch (error: any) {
    // バリデーションエラー（メールアドレス・パスワード間違いなど）
    if (error.isValidationError) {
      throw error
    }
    if (error.message) {
      throw new Error(error.message)
    }
    throw new Error('ログインに失敗しました。')
  }
}

/**
 * ログアウト
 * 
 * @throws Error ログアウト失敗時
 */
export const logout = async (): Promise<void> => {
  try {
    await apiFunction<LogoutResponse>(
      '/api/auth/logout',
      {},
      'POST'
    )
  } catch (error: any) {
    // エラーが発生してもトークンは削除する
  } finally {
    // トークンをlocalStorageから削除
    localStorage.removeItem('auth_token')
  }
}

/**
 * 現在の認証ユーザー情報を取得
 * 
 * @returns ユーザー情報（未認証の場合はnull）
 */
export const getAuthUser = async (): Promise<AuthUser | null> => {
  try {
    const result = await apiFunction<UserResponse>(
      '/api/auth/user',
      {},
      'GET'
    )
    
    if (!result || !result.user) {
      return null
    }

    return result.user
  } catch (error: any) {
    // 401の場合は未認証として扱う
    if (error.statusCode === 401) {
      return null
    }
    return null
  }
}
